module.exports = __webpack_public_path__ + "static/media/game-icon-stop.a6beebaf.png";